import lightModeLogo from '@assets/images/full-logo-light-mode.png'
import darkModeIso from '@assets/images/iso-dark-mode.png'
import lightModeIso from '@assets/images/iso-light-mode.png'
import loginBackground from '@assets/images/login-bg.png'
import { ThemeConfig } from '@gravitate-js/excalibrr'

export const themeConfigs: ThemeConfig[] = [
  {
    display: 'Crossroads Light',
    key: 'crossroads_light',
    isDark: false,
    default: true,
    colors: {
      info: '#9687F5',
      nav1: '#2D284B',
      nav2: '#9389d2',
    },
    nav: {
      bgColor: '#FFFFFF',
      routeActiveBgColor: 'var(--bg-3)',
      routeActiveTextColor: 'var(--theme-color-1)',
      routeHoverBgColor: 'var(--bg-2)',
      routeHoverTextColor: 'var(--theme-color-1)',
    },
    loginLogoImage: lightModeLogo,
    loginBackgroundImage: loginBackground,
    loginTransLogoImage: lightModeIso,
  },
  {
    display: 'Crossroads Dark',
    key: 'crossroads_dark',
    isDark: true,
    colors: {
      info: '#9687F5',
      nav1: '#2D284B',
      nav2: '#9389d2',
    },
    nav: {
      bgColor: '#1C1A2A',
      routeActiveBgColor: 'var(--theme-color-1-trans)',
      routeActiveTextColor: 'var(--theme-color-1)',
      routeHoverBgColor: 'var(--theme-color-1-trans)',
      routeHoverTextColor: 'var(--theme-color-1)',
      routeTextColor: 'white',
    },
    loginLogoImage: lightModeLogo,
    loginBackgroundImage: loginBackground,
    loginTransLogoImage: darkModeIso,
  },
]
